export const TIME_AND_ATTENDANCE_LOGS_TABLE_HEADERS = ["Team Member", "Date", "Start", "End"];
export const MANAGER_TIME_AND_ATTENDANCE_LOGS_TABLE_HEADERS = ["id", "label", "Edit Time and Attendance"];
export const CLIENT_TIME_AND_ATTENDANCE_LOGS_TABLE_HEADERS = ["id", "label"];
export const TIME_AND_ATTENDANCE_LOGS_TABLE_HEADERS_SELECT = ["Select", "id", "label", "Edit Time and Attendance"];

export const TIME_AND_ATTENDANCE_LOGS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/time-and-attendancelogs", name: "Clients" },
  { id: "/time-and-attendancelogs/:clientCode", name: ":clientCode" },
  { id: "/time-and-attendancelogs/:clientCode/:locationId", name: ":locationId" },
];

export const CLIENTS_TIME_AND_ATTENDANCE_LOGS_BREADCRUMBS = [
  { id: "/time-and-attendance", name: "Home" },
  { id: "/time-and-attendance/", name: ":clientCode" },
  { id: "/time-and-attendance/:locationId", name: ":locationId" },
];

export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1000000000;
